// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4077) return "static/chunks/4077-e5fd3ff2366742a7.js";
	if (chunkId === 8465) return "static/chunks/f4898fe8-455eacdfcf3cc9d8.js";
	if (chunkId === 6710) return "static/chunks/6710-680db74e64708861.js";
	if (chunkId === 4747) return "static/chunks/4747-f138a662274b25a6.js";
	if (chunkId === 4955) return "static/chunks/4955-0d54db371e041cbf.js";
	if (chunkId === 2839) return "static/chunks/2839-4b548ed333143422.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3581":"35ee0bb69def4aa3","5010":"bdf2a63d87d13e5a","5281":"359f2a470cb34a50","6715":"11e9872edb7d7acb","7011":"0c6b50f2cc050700","7290":"9aa67c82c1374a51","7765":"aae07efc9879dcdb","8225":"8921e6af2ba713df","8582":"1b842b13d1fde298","9853":"fa95e7c427f2e734"}[chunkId] + ".js";
};